import { Toast } from './toast.models';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace ToastActions {
  export class ShowSuccess {
    static readonly type = '[TOAST] Show Success';
    constructor(
      public text: string,
      public header?: string
    ) {}
  }

  export class ShowInformation {
    static readonly type = '[TOAST] Show Information';
    constructor(
      public text: string,
      public header?: string
    ) {}
  }

  export class ShowUserEvent {
    static readonly type = '[TOAST] Show User Event';
    constructor(
      public text: string,
      public header?: string
    ) {}
  }

  export class ShowError {
    static readonly type = '[TOAST] Show Error';
    constructor(public text: string) {}
  }

  export class ShowWarning {
    static readonly type = '[TOAST] Show Warning';
    constructor(public text: string) {}
  }

  export class Remove {
    static readonly type = '[TOAST] Remove';
    constructor(public toast: Toast) {}
  }
}
